import { Action } from 'types/redux'
import { Toastr } from 'components/global/Toastr'
import { handleResponseErr } from 'utils/apiHelperUtils'
import {
  ALFTPolicyType,
  PolicyDetailsResponseType,
} from 'containers/authorised/BenefitsManagement/AnnualFlightTicket/types'
import * as actions from './actions'

type StateType = {
  fetching: boolean
  policiesList: ALFTPolicyType[]
  policyDetails: PolicyDetailsResponseType
  destinations: { id: number; name_i18n: string; code: string }[]
}

export const initialState: StateType = {
  fetching: false,
  policiesList: [],
  policyDetails: {} as PolicyDetailsResponseType,
  destinations: [],
}

export default function reducer(state = initialState, action: Action): StateType {
  const { payload } = action
  switch (action.type) {
    case actions.LOAD_POLICIES_LIST_PENDING:
    case actions.GET_POLICIES_DETAILS_PENDING:
    case actions.UPDATE_POLICIES_DETAILS_PENDING:
    case actions.ACTIVATE_POLICIES_DETAILS_PENDING:
    case actions.DEACTIVATE_POLICIES_DETAILS_PENDING:
    case actions.CREATE_POLICIES_DETAILS_PENDING:
    case actions.DELETE_POLICIES_DETAILS_PENDING:
    case actions.GET_DESTINATIONS_PENDING:
      return {
        ...state,
        fetching: true,
      }

    case actions.UPDATE_POLICIES_DETAILS_FULFILLED:
    case actions.ACTIVATE_POLICIES_DETAILS_FULFILLED:
    case actions.DEACTIVATE_POLICIES_DETAILS_FULFILLED:
    case actions.CREATE_POLICIES_DETAILS_FULFILLED:
    case actions.DELETE_POLICIES_DETAILS_FULFILLED:
      Toastr.success(payload?.data?.message)
      return {
        ...state,
        fetching: false,
      }

    case actions.LOAD_POLICIES_LIST_FULFILLED:
      return {
        ...state,
        policiesList: payload?.data?.data?.flight_ticket_policies ?? [],
        fetching: false,
      }

    case actions.GET_POLICIES_DETAILS_FULFILLED:
      return {
        ...state,
        policyDetails: payload?.data?.data?.flight_ticket_policy,
        fetching: false,
      }

    case actions.GET_DESTINATIONS_FULFILLED:
      return {
        ...state,
        destinations: payload?.data?.data?.travel_destinations ?? [],
        fetching: false,
      }

    case actions.LOAD_POLICIES_LIST_REJECTED:
    case actions.GET_POLICIES_DETAILS_REJECTED:
    case actions.UPDATE_POLICIES_DETAILS_REJECTED:
    case actions.ACTIVATE_POLICIES_DETAILS_REJECTED:
    case actions.DEACTIVATE_POLICIES_DETAILS_REJECTED:
    case actions.CREATE_POLICIES_DETAILS_REJECTED:
    case actions.DELETE_POLICIES_DETAILS_REJECTED:
      Toastr.error(handleResponseErr(payload))
      return {
        ...state,
        fetching: false,
      }

    default:
      return state
  }
}
